import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import ToolPanel from '../components/ToolPanel';
import TipsWindow from '../components/TipsWindow';
import { useTip } from '../hooks/useTips';
import {
  TYPOGRAPHY_STYLES,
  FORM_STYLES,
  ROW_STYLES,
} from '../styles/viewerStyles';

function GaussianSplattingTools({
  currentViewMode,
  currentDisplayMode,
  switchViewMode,
  switchDisplayMode,
  toggleGaussianPanel,
  DRAWER_WIDTH
}) {
  const { t } = useTranslation();

  // Tips integration - component is only mounted when panel is open
  const { isOpen: isTipOpen, title: tipTitle, markdownBody: tipBody, close: closeTip } = useTip('gaussianSplatting', true);

  return (
    <>
    <TipsWindow
      isOpen={isTipOpen}
      title={tipTitle}
      markdownBody={tipBody}
      onClose={({ doNotShowAgain }) => closeTip(doNotShowAgain)}
    />
    <ToolPanel
      title={t('GaussianSplatting') || 'Gaussian Splatting'}
      onClose={toggleGaussianPanel}
      width={DRAWER_WIDTH}
    >
      {/* View Selection Dropdown */}
      <Box sx={ROW_STYLES.sliderRow}>
        <Typography variant="caption" sx={TYPOGRAPHY_STYLES.captionWithLabel}>
          {t('View') || 'View'}:
        </Typography>
        <FormControl sx={{ flex: 1 }}>
          <Select
            value={currentViewMode}
            onChange={(e) => switchViewMode(e.target.value)}
            size="small"
            sx={FORM_STYLES.select}
            MenuProps={FORM_STYLES.selectMenuProps}
          >
            <MenuItem value="full">
              <Typography variant="caption" sx={{ fontSize: '0.75rem' }}>
                {t('FullScreen') || 'Full Screen'}
              </Typography>
            </MenuItem>
            <MenuItem value="split">
              <Typography variant="caption" sx={{ fontSize: '0.75rem' }}>
                {t('SplitScreen') || 'Split Screen'}
              </Typography>
            </MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* Radio Buttons - only show when in full model mode */}
      {currentViewMode === 'full' && (
        <Box sx={{ mb: 1.5 }}>
          <FormControl component="fieldset" sx={{ width: '100%' }}>
            <RadioGroup
              row
              value={currentDisplayMode}
              onChange={(e) => switchDisplayMode(e.target.value)}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                flexWrap: 'nowrap',
                '& .MuiFormControlLabel-label': {
                  color: '#fff',
                  fontSize: '0.65rem'
                },
                '& .MuiFormControlLabel-root': {
                  marginRight: 2
                }
              }}
            >
              <FormControlLabel
                value="pointcloud"
                control={<Radio sx={FORM_STYLES.radio} />}
                label={t('PointCloud') || 'Point Cloud'}
              />
              <FormControlLabel
                value="gaussian"
                control={<Radio sx={FORM_STYLES.radio} />}
                label={t('GaussianSplatting') || 'Gaussian Splatting'}
              />
            </RadioGroup>
          </FormControl>
        </Box>
      )}
    </ToolPanel>
    </>
  );
}

GaussianSplattingTools.propTypes = {
  currentViewMode: PropTypes.string.isRequired,
  currentDisplayMode: PropTypes.string.isRequired,
  switchViewMode: PropTypes.func.isRequired,
  switchDisplayMode: PropTypes.func.isRequired,
  toggleGaussianPanel: PropTypes.func.isRequired,
  DRAWER_WIDTH: PropTypes.number.isRequired
};

export default GaussianSplattingTools;
